const sharedSettings = {
  area: { editable: true, type: 'hm-area-select', rules: [{ required: false }] },

  name: { editable: true, type: 'input', rules: [{ required: true }] },
  code: { editable: true, type: 'input', rules: [{ required: false }] },
  description: { editable: true, type: 'textarea', rules: [{ required: false }] },

  created_at: { hidden: true },
  updated_at: { hidden: true },

  area_name: { hidden: true },
  area_user_type: { hidden: true },
}

export const settings = {
  id: { label: "ID" },
  ...sharedSettings
};

export const initialSettings = {
  id: { hidden: true },
  ...sharedSettings,
}

export const initialValues = {
  name: "",
  description: "",
  code: "",
};
